<template>
  <div class="app-wrapper">
    <Navbar v-if="ready" />

    <div class="app-main pt-4">
      <slot />
    </div>
  </div>
</template>

<script>
import Navbar from './Navbar.vue';

export default {
  name: 'DefaultLayout',

  components: {
    Navbar
  },

  props: {
    ready: {
      type: Boolean,
      default: false
    }
  }
};
</script>
